import React, { useState, useEffect, useRef } from 'react';

type Props = {};

export type WithDelayedLoading = {
  loading?: boolean;
  removeLoading: () => void;
  setLoading: () => void;
};

const withDelayedLoading =
  <ComponentProps extends Props>(
    WrappedComponent: React.ComponentType<ComponentProps>,
  ): React.FC<ComponentProps> =>
  (props: ComponentProps) => {
    const [loading, setLoadingState] = useState(false);
    const buttonTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const setLoading = () => {
      buttonTimerRef.current = setTimeout(() => {
        setLoadingState(true);
      }, 200);
    };

    const removeLoading = () => {
      setLoadingState(false);
      if (buttonTimerRef.current) clearTimeout(buttonTimerRef.current);
    };

    useEffect(
      () => () => {
        if (buttonTimerRef.current) clearTimeout(buttonTimerRef.current);
      },
      [],
    );

    return (
      <WrappedComponent
        {...props}
        loading={loading}
        setLoading={setLoading}
        removeLoading={removeLoading}
      />
    );
  };

export default withDelayedLoading;
